import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'user',
  initialState: {
    isLoggedIn: false,
    userData: null,
  },
  reducers: {
    loginUser: (state, action) => {
      state.isLoggedIn = true;
      state.userData = action.payload;
    },
    logoutUser: (state) => {
      state.isLoggedIn = false;
      state.userData = null;
    },
  },
});

export const { loginUser, logoutUser } = userSlice.actions;
export const selectUser = (state) => state.user;

export default userSlice.reducer;
